export default {
  name: "selva raj",
  feedback: `Salem Cake Craft Studio is famous for its easy-to-understand explanations by Ramya mam. She teaches everything in a way that everyone can understand. 
  Her teaching is very thorough and clear. ma'am, everyone at our house taste and enjoy our bread recipes. my kids really enjoyed it. 
  It tasted great. Thank you so much mam ❤`
};
